"use client";
import Flyout from "../_private/Flyout/index.js";
import Text from "../Text/index.js";
import Theme from "../Theme/index.js";
import React from "react";
import s from "./Tooltip.module.css";
const Tooltip = (props) => {
    const { id, text, children, onOpen, onClose, position = "bottom", active } = props;
    return (React.createElement(Flyout, { id: id, active: active, position: position, onOpen: onOpen, onClose: onClose, triggerType: "hover" },
        React.createElement(Flyout.Trigger, null, children),
        React.createElement(Flyout.Content, null,
            React.createElement(Theme, null,
                React.createElement(Text, { variant: "body-3", className: s.root }, text)))));
};
export default Tooltip;
